"use client"

import { useEffect } from "react"
import { Button } from "@/components/ui/button"
import posthog from "posthog-js"

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    posthog.captureException(error, { boundary: "root" })
  }, [error])

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center space-y-4 max-w-md">
        <h2 className="text-xl font-semibold">Something went wrong</h2>
        <p className="text-muted-foreground text-sm">
          An unexpected error occurred. Please try again.
        </p>
        <Button onClick={reset}>Try again</Button>
      </div>
    </div>
  )
}
